export class TimeZone {
	name: string;
	offsetMins: number;
	offsetLabel: string;
}
